const getEarlyAccessProductsCount = savedItemProducts =>
  savedItemProducts.filter(({ earlyAccess }) => !!earlyAccess).length;

export default getEarlyAccessProductsCount;
